import { useSelector } from 'react-redux'
import { LeftOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Image from '~/core/Image'
import Link from '~/core/Link'
import Text from '~/core/Text'
import icons from '~/apps/consumer/icons'
import { isTeamsFeatureEnabled } from '~/redux-modules/identity'

import styles from './styles.css'

type DrawerTitlePropsType = {
    onClick: () => void
    subMenuVisible: boolean
    requestTrialLoading?: boolean
    requestTrialDisabled?: boolean
    showTeamsEnabledTitle?: boolean
}

export default function DrawerTitle(props: DrawerTitlePropsType) {
    const {
        onClick,
        subMenuVisible,
        requestTrialLoading,
        requestTrialDisabled,
        showTeamsEnabledTitle,
    } = props

    const PLACEMENT = 'premium-upsell-drawer'

    const isTeamsFeatureOn =
        useSelector(isTeamsFeatureEnabled) || showTeamsEnabledTitle
    const premiumUpsellDrawerColor = isTeamsFeatureOn ? '#E8FCF5' : ''
    const drawerHeaderImg = isTeamsFeatureOn
        ? icons.premiumHeaderImg
        : icons.nonpremiumUpsellSidebarImg

    const marginBottom = isTeamsFeatureOn ? '16px' : '4px'

    return (
        <Box
            alignItems="center"
            backgroundColor={premiumUpsellDrawerColor}
            direction="col"
            position="relative"
            paddingBottom="8px"
        >
            {subMenuVisible && (
                <Link
                    data-test-target={`back-${PLACEMENT}`}
                    className={styles.backButton}
                    name="back"
                    onClick={(evt: Event) => {
                        evt.preventDefault()
                        onClick()
                    }}
                    placement={PLACEMENT}
                >
                    <LeftOutlined />
                    <Box fontSize="14px" display="inline" marginTop="-2px">
                        Back
                    </Box>
                </Link>
            )}
            <Image
                src={drawerHeaderImg}
                style={{ marginTop: '32px', marginBottom: marginBottom }}
                width="260px"
                height="110px"
            />
            <Text
                fontWeight={600}
                fontSize="24px"
                style={{ lineHeight: '32px', marginTop: '8px' }}
            >
                {isTeamsFeatureOn
                    ? 'Welcome to Fictiv Premium'
                    : 'Try Fictiv Premium'}
            </Text>
            <Text
                fontSize="14px"
                fontWeight={400}
                color="blackAlpha65"
                style={{
                    textAlign: 'center',
                    padding: '8px 0px',
                    lineHeight: '22px',
                    width: '352px',
                }}
            >
                Coordinate custom part sourcing with greater visibility and
                control across teams.
            </Text>
            {isTeamsFeatureOn ? (
                <>
                    <Box marginTop="8px">
                        <Button
                            name={`${PLACEMENT}-getting-started`}
                            style={{
                                width: '388px',
                                height: '40px',
                                lineHeight: '40px',
                            }}
                            type="primary"
                            placement={PLACEMENT}
                            href={
                                'https://www.fictiv.com/pdf/fictiv-premium-onboarding-guide'
                            }
                            target="_blank"
                            data-test-target={`${PLACEMENT}-getting-started-btn`}
                        >
                            <Text>Getting started</Text>
                        </Button>
                    </Box>
                    <Box margin="8px 0">
                        <Button
                            name={`${PLACEMENT}-help-center`}
                            href={
                                'https://help.fictiv.com/en/collections/3602423-fictiv-premium'
                            }
                            target="_blank"
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-help-center-btn`}
                            style={{
                                width: '388px',
                                height: '40px',
                                lineHeight: '40px',
                            }}
                        >
                            <Text>Help center</Text>
                        </Button>
                    </Box>
                </>
            ) : (
                <>
                    <Box marginTop="8px">
                        <Button
                            name="request-free-trial"
                            style={{ width: '388px', height: '40px' }}
                            type="primary"
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-request-free-trial-button`}
                            onClick={onClick}
                            loading={requestTrialLoading}
                            disabled={requestTrialDisabled}
                        >
                            <Text style={{ padding: '8px 16px' }}>
                                Request free trial
                            </Text>
                        </Button>
                    </Box>
                    <Box margin="8px 0">
                        <Button
                            name={`${PLACEMENT}-learn-more-button`}
                            href={'https://www.fictiv.com/premium'}
                            target="_blank"
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-learn-more`}
                            style={{
                                width: '388px',
                                height: '40px',
                                lineHeight: '40px',
                            }}
                        >
                            <Text>Learn more</Text>
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    )
}
